import { ProfessionalPartnership } from 'commons/types/DTO/commons'

import { ProfessionalPartnershipFormValue } from '../../../../types'

export const mapProfessionalPartnershipForm = (
  formValues: ProfessionalPartnershipFormValue
): ProfessionalPartnership => ({
  ...formValues
})
